import * as cx from 'classnames';
import { REPLY_LINK } from 'mk/autogenerated/translations/ReplyButton.1c71acb1fc4bd0d96ec7ec1a1a1b8f93'
import * as React from 'react';
import styles from './ReplyButton.mscss';

interface OwnProps {
    className?: string;

    onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

type Props = OwnProps;

class ReplyButton extends React.PureComponent<Props> {

    public render() {
        const { className, onClick } = this.props;

        return (
            <button type="button" className={cx(styles.ReplyButton, className)} onClick={onClick}>
                <i className={cx('fa fa-comment-o', styles.ReplyButton__icon)} />
                {REPLY_LINK}
            </button>
        );
    }

}

export default ReplyButton;
